export const DOMAIN = process.env.VUE_APP_BASE_URL || `${window.location.protocol}//${window.location.hostname}`;
export const BASE_URL = `${DOMAIN}/api/v1`;

export const CONFIGURATIONS = `${BASE_URL}/core/configurations/`;
export const SIGNIN = `${BASE_URL}/user/signin/`;
export const SIGNUP = `${BASE_URL}/user/signup/`;
export const RESEND_CONFIRMATION = `${BASE_URL}/user/resend_confirmation/{user_id}/`;
export const SIGNOUT = `${BASE_URL}/user/signout/`;
export const RESET_LINK = `${BASE_URL}/user/reset_link/`;
export const RESET_PASSWORD = `${BASE_URL}/user/reset_password/`;
export const CONFIRM = `${BASE_URL}/user/confirm/`;
export const SUBSCRIBE = `${BASE_URL}/mailing/subscribe/`;
export const SPACES_LIST = `${BASE_URL}/space/space/`;
export const SPACES_DETAIL = `${BASE_URL}/space/space/{space_id}/`;
export const SPACES_USAGE = `${BASE_URL}/space/space/{space_id}/usage/`;
export const SPACES_AVAILABLE_LIST = `${BASE_URL}/space/space/available/`;
export const SPACES_JOIN_REQUEST = `${BASE_URL}/space/join_request/{space_id}/`;
export const SPACE_PARTICIPANTS = `${BASE_URL}/space/participants/{space_id}/`;
export const SPACE_TEAMS_LIST = `${BASE_URL}/space/space/{space_id}/team/`;
export const SPACE_TEAMS_DETAIL = `${BASE_URL}/space/space/{space_id}/team/{team_id}/`;
export const SPACE_MEMBERS_LIST = `${BASE_URL}/space/space_member/`;
export const SPACE_MEMBERS_DETAIL = `${BASE_URL}/space/space_member/{id}/`;
export const TEAM_MEMBERS_LIST = `${BASE_URL}/space/team_member/`;
export const TEAM_MEMBERS_DETAIL = `${BASE_URL}/space/team_member/{id}/`;
export const TEAMS_LIST = `${BASE_URL}/space/team/`;
export const TEAMS_DETAIL = `${BASE_URL}/space/team/{id}/`;
export const INVITE_LIST = `${BASE_URL}/space/invitation/{space_id}/`;
export const INVITE_DETAIL = `${BASE_URL}/space/invitation/{key}/`;
export const USERS_LIST = `${BASE_URL}/user/user/`;
export const USER_UPDATE = `${BASE_URL}/user/user_settings/`;
export const USER_CHANGE_PASSWORD = `${BASE_URL}/user/change_password/`;
export const TOPICS_LIST = `${BASE_URL}/content/{space_id}/topic/`;
export const TOPICS_DETAIL = `${BASE_URL}/content/{space_id}/topic/{topic_id}/`;
export const TOPICS_GENERAL = `${BASE_URL}/content/{space_id}/topic/{topic_id}/general/`;
export const TOPIC_MEMBERS_LIST = `${BASE_URL}/content/{space_id}/topic/{topic_id}/members/`;
export const TOPIC_MEMBERS_DETAIL = `${BASE_URL}/content/{space_id}/topic/{topic_id}/members/{member_id}/`;
export const TOPICS_BOOKMARK = `${BASE_URL}/content/{space_id}/topic/{topic_id}/bookmark/`;
export const TREE = `${BASE_URL}/content/{space_id}/collection/tree/`;
export const COLLECTION_LIST = `${BASE_URL}/content/{space_id}/collection/`;
export const COLLECTION_DETAIL = `${BASE_URL}/content/{space_id}/collection/{collection_id}/`;
export const NOTES_LIST = `${BASE_URL}/content/{space_id}/note/`;
export const NOTES_DETAIL = `${BASE_URL}/content/{space_id}/note/{note_id}/`;
export const NOTES_LOCK = `${BASE_URL}/content/{space_id}/note/{note_id}/lock/`;
export const NOTES_DUPLICATE = `${BASE_URL}/content/{space_id}/note/{note_id}/duplicate/`;
export const NOTE_VERSIONS_LIST = `${BASE_URL}/content/{space_id}/note/{note_id}/versions/`;
export const NOTE_VERSIONS_DETAIL = `${BASE_URL}/content/{space_id}/note/{note_id}/versions/{version_id}/`;
export const NOTE_VERSION_RESTORE = `${BASE_URL}/content/{space_id}/note/{note_id}/versions/{version_id}/restore/`;
export const EMPTY_TRASH = `${BASE_URL}/content/{space_id}/empty_trash/`;
export const NOTES_BOOKMARK = `${BASE_URL}/content/{space_id}/note/{note_id}/bookmark/`;
export const ATTACHMENTS_LIST = `${BASE_URL}/content/{space_id}/note/{note_id}/attachment/`;
export const ATTACHMENTS_DETAIL = `${BASE_URL}/content/{space_id}/note/{note_id}/attachment/{attachment_id}/`;
export const IMAGES_LIST = `${BASE_URL}/content/{space_id}/images/`;
export const COMMENTS_LIST = `${BASE_URL}/content/{space_id}/note/{note_id}/comment/`;
export const COMMENTS_DETAIL = `${BASE_URL}/content/{space_id}/note/{note_id}/comment/{comment_id}/`;
export const NOTE_TAGS_LIST = `${BASE_URL}/content/{space_id}/note/{note_id}/tag/`;
export const NOTE_TAGS_DETAIL = `${BASE_URL}/content/{space_id}/note/{note_id}/tag/{tag_id}/`;
export const TAGS_LIST = `${BASE_URL}/content/{space_id}/tag/`;
export const TAGS_DETAIL = `${BASE_URL}/content/{space_id}/tag/{tag_id}/`;
export const SAVED_SEARCH_LIST = `${BASE_URL}/content/{space_id}/saved_searches/`;
export const SAVED_SEARCH_DETAIL = `${BASE_URL}/content/{space_id}/saved_searches/{saved_search_id}/`;
export const FLOW_LIST = `${BASE_URL}/kanban/{space_id}/flow/`;
export const FLOW_DETAIL = `${BASE_URL}/kanban/{space_id}/flow/{flow_id}/`;
export const MILESTONE_LIST = `${BASE_URL}/kanban/{space_id}/milestone/`;
export const MILESTONE_DETAIL = `${BASE_URL}/kanban/{space_id}/milestone/{milestone_id}/`;
export const COLUMN_LIST = `${BASE_URL}/kanban/{space_id}/flow/{flow_id}/column/`;
export const COLUMN_DETAIL = `${BASE_URL}/kanban/{space_id}/flow/{flow_id}/column/{column_id}/`;
export const CARD_LIST = `${BASE_URL}/kanban/{space_id}/flow/{flow_id}/card/`;
export const CARD_DETAIL = `${BASE_URL}/kanban/{space_id}/flow/{flow_id}/card/{card_id}/`;
export const ASSIGNEE_LIST = `${BASE_URL}/kanban/{space_id}/flow/{flow_id}/card/{card_id}/assignee/`;
export const ASSIGNEE_DETAIL = `${BASE_URL}/kanban/{space_id}/flow/{flow_id}/card/{card_id}/assignee/{assignee_id}/`;
